export default "__VITE_PUBLIC_ASSET__adee5d41__"